import React from "react"
import { createMarkup } from "utils/createMarkup"
import { preventWidow } from "utils/preventWidow"
import { bannerText, desktopBanner, mobileBanner } from "./SkinnyBanner.css"

type BannerTextProps = {
  text?: string
  preventWidows?: boolean | null
  id?: string
}

export const BannerText: React.FC<BannerTextProps> = ({
  text,
  preventWidows,
  id,
}) => {
  const style = id === "SkinnyBannerDesktopText" ? desktopBanner : mobileBanner

  if (!text) return null

  return (
    <span
      data-testid={id}
      className={`${bannerText} ${style}`}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={
        preventWidows ? preventWidow(text) : createMarkup(text)
      }
    />
  )
}
